import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import fetchContent from '../redux/actions/content';
import { errorLogger, shouldLoadData } from '../utils';
import { getPageData } from '../redux/selectors/pages';
import { getComponent, getContentType, getDataModel } from './pageList';

import { NotFoundpage } from './ErrorPage/errorPages';

class RootPage extends React.Component {
  static defaultProps = {
    data: undefined,
  };

  static propTypes = {
    data: PropTypes.shape({}),
    fetchContent: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    match: PropTypes.shape().isRequired,
    updateError: PropTypes.func.isRequired,
    location: PropTypes.shape({}).isRequired,
  };

  componentWillMount = () => this.loadData();

  componentDidUpdate = prevProps => {
    const { locale, match } = this.props;
    const { lvl1, lvl2, lvl3 } = match.params;
    const { locale: prevLocale, match: prevMatch } = prevProps;
    const { lvl1: prevLvl1, lvl2: prevLvl2, lvl3: prevLvl3 } = prevMatch.params;
    if (locale !== prevLocale || lvl1 !== prevLvl1 || lvl2 !== prevLvl2 || lvl3 !== prevLvl3) {
      this.loadData();
    }
  };

  loadData = () => {
    const { data, fetchContent, locale, match, updateError } = this.props;
    const { lvl1, lvl2, lvl3 } = match.params;
    const dataModel = getDataModel(lvl1, lvl2, lvl3);
    if (dataModel && shouldLoadData(dataModel, data)) {
      const params = { locale };

      const contentType = getContentType(lvl1, lvl2, lvl3);
      if (contentType) params.contentType = contentType;

      if (lvl3 && lvl1 === 'range') {
        params.slug = lvl3;
      } else if (lvl2) {
        params.slug = lvl2;
      }

      if (lvl3 && lvl1 === 'salon-list') {
        params.slug = lvl3;
      }

      if (lvl3 && lvl1 === 'inspiration') {
        params.slug = lvl3;
      }

      if (contentType) {
        fetchContent(params)
          .then(res => {
            const { error } = res.action.payload.data;
            if (error) updateError(error);
            return res;
          })
          .catch(e => {
            errorLogger(e);
            updateError(e);
          });
      }
    }
  };

  render() {
    const { data, location, match, locale } = this.props;
    const { lvl1, lvl2, lvl3 } = match.params;

    const comp = getComponent(lvl1, lvl2, lvl3);
    if (comp) return comp(data, location, locale);

    return <NotFoundpage />;
  }
}

const mapState = (state, props) => ({
  data: getPageData(state, { ...props, dataLevel: 3 }),
  locale: state.locale,
});

const mapDispatch = dispatch => ({
  fetchContent: params => dispatch(fetchContent(params)),
  updateError: error => dispatch({ type: 'UPDATE_ERROR', error }),
});

export default connect(mapState, mapDispatch)(RootPage);



// WEBPACK FOOTER //
// ./src/pages/RootPage.js